import { render, staticRenderFns } from "./CourseOrderList.vue?vue&type=template&id=276719dc&scoped=true&"
import script from "./CourseOrderList.vue?vue&type=script&lang=js&"
export * from "./CourseOrderList.vue?vue&type=script&lang=js&"
import style0 from "./CourseOrderList.vue?vue&type=style&index=0&id=276719dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276719dc",
  null
  
)

export default component.exports